export default function renderAdrTaMaterialsV3(data) {
  return function (pdf) {};
}
